"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const _1 = require("./");
const lib_1 = require("react-mdc-web/lib");
class Drawer extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClose = () => {
            this.scrollbars.scrollToTop();
            this.props.onClose();
        };
    }
    render() {
        const { children, open, title } = this.props;
        return (React.createElement(lib_1.Drawer, { className: "mdc-typography main-drawer", open: open, onClose: this.handleClose, style: { display: 'block' } },
            React.createElement(lib_1.DrawerHeader, null,
                React.createElement(lib_1.DrawerHeaderContent, null,
                    React.createElement("h2", { className: "title" }, title),
                    React.createElement("button", { type: "button", className: "btn btn-close-nav toggle-drawer", onClick: this.handleClose },
                        React.createElement(_1.Icon, { name: "arrow_back" })))),
            React.createElement(lib_1.DrawerContent, null,
                React.createElement(_1.Scrollbars, { offsetHeight: '70px', ref: (instance) => this.scrollbars = instance }, children))));
    }
}
Drawer.defaultProps = {
    open: false,
};
exports.Drawer = Drawer;



//////////////////
// WEBPACK FOOTER
// ./src/components/Drawer.tsx
// module id = 108
// module chunks = 0